import { render, staticRenderFns } from "./CheckBoxField.vue?vue&type=template&id=2f4ecde0&scoped=true"
import script from "./CheckBoxField.vue?vue&type=script&lang=ts"
export * from "./CheckBoxField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4ecde0",
  null
  
)

export default component.exports